import script from "./MainApi.vue?vue&type=script&lang=js"
export * from "./MainApi.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__